module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gi-e73af10429f00dc293ea3230387af7b6.svg";